import Vue from 'vue';
import EditDataTable from './src/table.vue';
Vue.component('edit-data-table', EditDataTable);

export default EditDataTable;
